import { objectKeysToCamelCase } from '@heidi-pay/heidi-common-fe/utils/objectKeysToCamelCase';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { QueryKey } from '@tanstack/react-query';
import { ApplicationDocumentUploads } from '@components/ApplicationDocuments/ApplicationDocumentUploads';
import { useGetOrderApplicationDetailsQuery } from '@components/ApplicationDocuments/queries';
import { Portals } from '@utils/constants';

const StyledGrid = styled(Grid)({
  '& > section': {
    height: 'calc(100% - 20px)',
  },
});

interface IApplicationDocumentWrapper {
  children: React.ReactNode;
  externalContractUuid: string | undefined;
  queryKey: QueryKey;
}

export const ApplicationDocumentWrapper = ({
  children,
  externalContractUuid,
  queryKey,
}: IApplicationDocumentWrapper) => {
  const { orderApplicationDetailsData } = useGetOrderApplicationDetailsQuery({
    externalContractUuid,
    portal: Portals.MERCHANT,
  });

  const { customerAgreementSigningOverview, manualIdentityUploadSummary } =
    objectKeysToCamelCase(orderApplicationDetailsData) ?? {};

  const documentsNeedToBeUploaded =
    customerAgreementSigningOverview?.isManualSigningRequired ||
    manualIdentityUploadSummary?.isManualIdentityDocumentUploadRequired;

  return (
    <Grid container={true} spacing={2}>
      <>
        <StyledGrid
          item={true}
          lg={documentsNeedToBeUploaded ? 6 : 12}
          xl={documentsNeedToBeUploaded ? 5 : 12}
          xs={12}
        >
          {children}
        </StyledGrid>

        {orderApplicationDetailsData && documentsNeedToBeUploaded ? (
          <StyledGrid item={true} lg={6} xl={7} xs={12}>
            <ApplicationDocumentUploads
              externalContractUuid={externalContractUuid}
              orderApplicationDetailsData={orderApplicationDetailsData}
              queryKey={queryKey}
            />
          </StyledGrid>
        ) : null}
      </>
    </Grid>
  );
};
